<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content">
    <Header :tabIndex="tabIndex"></Header>
    <el-image
      class="bg_img"
      fit="cover"
      src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/wt_1.png"
    ></el-image>
    <el-image
      class="bg_img1"
      fit="cover"
      src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/wt_2.png"
    ></el-image>
    <el-image
      class="bg_img2"
      fit="cover"
      src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/wt_3.png"
    ></el-image>
    <div class="nav">
      <div class="nav_head">
        <img
          @click="returnPage"
          class="img"
          src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/return.png"
          alt=""
        />
        <div class="nav_title">二白机器人官方网站使用条款</div>
      </div>
      <div class="list">
        <div class="list_item" v-for="(item, index) in list" :key="index">
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header_h5.vue"
import Footer from "@/components/footer_h5.vue"

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      tabIndex: -1,
      list: [
        {
          title: "使用条款",
          text: "使用条款适用于二白消费者业务官网。您使用本网站，即表示您同意本使用条款； 如果您不同意，请勿使用本网站。 在法律允许范围内，二白保留自行决定任何时候变更本使用条款内容的权利，您有责任定期查看本使用条款的变更。您在变更信息发布之后继续使用本网站，即表示您同意且接受该变更。",
        },
        {
          title: "网站信息及说明",
          text: "二白在其所在地中华人民共和国浙江省管理及运营本网站。尽管在全世界均可访问本网站，但并非所有通过本网站或在本网站上讨论、提及、供应或提供的功能、产品或服务均可由所有人或在所有地理位置获得。 若您选择在中国之外的国家或地区访问本网站，系出于您本人的决定，且您应自行负责遵守适用的当地法律。",
        },
        {
          title: "网站内容",
          text: "本网站包含的所有文字、图片、音乐、视频、动画、商标、图案、图表、可视界面及计算机编码（“内容”），包括但不限于内容的创意、设计、结构、表现方式、呈现结果等，均属二白所有、受二白控制或者由二白获得合法授权而使用。除非本使用条款明确规定，未经二白事先书面同意，您不得为任何商业目的以任何方式使用本网站的内容。 您可以从本网站下载二白提供的关于二白产品和服务的信息，前提是：\n（一）仅出于个人而非商业目的；\n（二）不对该类信息作任何修改；\n（三）不对该类信息及载有信息的文件做出进一步的陈述和保证；\n（四）不移除任何表明二白所有权等合法权益的声明或者通知。",
        },
        {
          title: "使用规范",
          text: "您不可为任何非法或本使用条款禁止的目的使用本网站，不得利用本网站及其内容侵犯其他组织或个人的合法权益。 您不可使用包括spider，robot，deep-link, page-scrape在内的，任何形式的装置、程序、算法或者任何相同或相似的手动程序，访问、获取、复制或监测本网站任何部分或任何内容，亦不可通过任何非本网站提供的方式访问、获取、复制本网站的任何资料、文件或信息。 您不可试图通过非法侵入、破解密码或任何其他非法方式，未经授权访问本网站的任何内容或使用本网站的任何服务。你不可追踪、反向查找、破解、破译本网站的任何客户的信息，包括但不限于任何非您所有的二白账户。 您不可违反本网站或链接至本网站的任何网络安全机制或认证措施，不可探测、扫描或者测试本网站或连接至本网站的任何网络弱点，您不可向本网站发起任何形式的网络攻击。 您同意不使用任何设备、软件或程序，干扰或试图干扰本网站的正常运行或在本网站进行的任何交易，或干扰或试图干扰他人使用本网站。你不得采取任何行为，在本网站基础架构、系统或网络上，或链接至本网站的系统或网络上，存储不合理或不合比例的的大量数据。",
        },
        {
          title: "外部链接",
          text: "本网站可能含有其他独立第三方网站的链接，该类链接仅为方便本网站的访问者而提供。二白不对链接网站的内容、服务、信息等提供任何明示和暗示的保证，此类链接也不视为二白对链接网站的推荐或授权。您需自行独立判断您与链接网站的互动行为，二白对此不承担任何责任。",
        },
        {
          title: "权利保留",
          text: "二白保留在任何时候不经通知进行以下行为的权利：\n（一）基于任何原因，暂停或终止本网站全部或部分的运行和访问；\n（二）修改或变更本网站的全部或部分内容及其适用的政策或条款；\n（三）在进行定期或非定期维护、错误纠正或其他变更所必须时，中断本网站全部或部分的运行和访问。",
        },
        {
          title: "免责声明",
          text: "对本网站及其所载内容与服务的可用性、持续性、可访问性，二白不做任何形式的保证，本网站及其内容是基于“现状”提供。您对本网站及任何链接网站的使用，由您承担全部责任。 本网站公布的各类产品或服务的信息，包括但不限于产品功能、配置、参数、技术规格、服务内容等，可能因不同国家/地区的不同发生变化；即使是同一产品，在其产品生命周期的不同阶段，其产品功能、配置、参数、技术规格等也可能进行调整，而二白需要时间去完成相应信息的更新，因此您所看到的产品或服务的信息和您实际购买的或您可以在市场上购买到的产品或服务有可能存在差异。二白不为本网站所载内容的正确性、完全性、可靠性提供保证。",
        },
        {
          title: "责任限制",
          text: "除法律禁止外，在任何情况下，对用户因使用本网站而受到的任何间接、衍生、惩戒、附带或惩罚性损害，包括但不限于利益损失，二白不承担任何责任，即使二白已知悉可能发生前述损害。 因您使用本网站而产生的任何损害或损失，二白及其合作伙伴对您全部的、最大的责任，不超过因您使用本网站任何服务或功能有关的订购费用或类似费用的总额。 某些司法管辖区不允许责任限制，因此前述限制可能不适用于您。",
        },
        {
          title: "赔偿",
          text: "对于任何第三方向二白提出的，因您使用本网站而产生的或与之有关的任何请求、损失、责任、主张或费用 (包括律师费)，您同意赔偿二白及其董事、高级职员、雇员、代理商、合作伙伴、代理人及许可人。",
        },
        {
          title: "反馈",
          text: "您在本网站提供的任何反馈均视为非保密，二白可随时不受限制地使用该类信息。",
        },
        {
          title: "本使用条款的违反",
          text: "您同意，若二白认为您违反了本使用条款，二白可以自行决定且无需提前通知，终止您访问本网站的权限和/或阻止您访问本网站。因对本使用条款的任何违反而导致二白终止您访问本网站的权限，二白概不对您或任何第三方承担责任。 您同意，二白可自行决定且无需提前通知，因下列原因终止您访问本网站全部或部分功能的权限，包括 (但不限于)：\n(一) 应法律执行机构或其他政府机构的要求；\n(二) 应您的要求（如您要求删除账户，则可能无法享受在线购物功能）；\n(三) 本网站或本网站提供的任何服务的中止或重大修改；\n(四) 不可预期的技术问题。",
        },
        {
          title: "适用法律和管辖",
          text: "本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律。 本协议签订地为深圳市龙岗区，如双方就本协议的内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向协议签订地有管辖权的人民法院提起诉讼。",
        },
        {
          title: "商品信息与商品价格",
          text: "1.本网站的商品信息随时都有可能发生变动，二白机器人小程序不作特别通知。二白机器人小程序将尽合理的商业努力，使网站内展示的商品参数、说明、库存、限购数量等商品信息尽可能准确、详细，但由于网站上商品信息的数量极其庞大，且受互联网技术发展水平等因素的限制，本网站不排除部分信息会存在滞后或差错的可能性。您确认：对此情形您表示知悉并理解，并同意不追究二白机器人小程序的相关责任。二白机器人小程序欢迎纠错，并会视情况给予纠错者一定的奖励。\n2.二白机器人小程序对商品进行明码标价，但您应当了解并同意，二白机器人小程序的商品价格信息随时都有可能发生变动，因此商品成交价格须以二白机器人小程序确认您提交订单结算时的价格为准。",
        },
        {
          title: "禁止代购销售与异常订单处理",
          text: "1.二白机器人作为定位于向个人消费者提供产品和服务的平台，为保护广大个人消费者权益，二白不允许代购销售。代购是指通过购买二白的商品并将其转售给直接客户的行为。您同意并确认，会严格遵守华为商城“禁止代购销售”的相关规定，若违反此规定，二白有权采取包括但不限于取消订单、禁止交易、删除帐号等措施，同时，二白保留追究违规用户责任的权利。\n2.您同意并确认，在商品未出库或未签收之前, 若发生以下任一情形，二白有权单方面原路退款到支付人账户，并取消订单：\n3.（1）订单为非正常流程产生；\n4.（2）订单生成后，因该用户的帐号权属产生争议或纠纷，当事人无法就争议达成一致，并且二白收到相关凭证；\n5.（3）订单生成后，订购人或付款人对交易提出异议，并且二白收到相关凭证；\n6.（4）订购人的用户帐号违反限购规定，或在一段时间内通过多个用户帐号下单，虽然单个帐号未违反限购规定，但通过订单的金融支付帐号、收货地址、下单IP地址、联系电话等判断实际购买人为一人或与此人有紧密关联，且多笔订单合计购买数量违反限购规定的；\n7.（5）其它二白认为通过不正当手段进行刷单的情形。",
        },
        {
          title: "配送",
          text: "1.为了快速准确地进行商品配送，您需填写详细准确的收货人姓名、收货人电话、收货地址等信息，并保持通信工具畅通。请您在收货前验视所送货物，当您或您指定的收货人、代理人在配送单或其他凭证上签字，即视为您完成收货，并认可收货商品。如果因为您填写的收货人姓名、收货人电话、收货地址等信息错误，导致将货物交付给非您本意的收货人的，由此造成的损失全部由您自行承担。\n2.因如下情况造成订单延迟配送或无法配送的，二白不承担配送责任，并保留单方取消订单的权利：\n3.(1) 您提供的收货信息不实、不准确或不完整；\n4.(2) 货物送达后无人签收；\n5.(3) 和收货人联系不上时，如收货人电话停机或不接听电话；\n6.(4) 第三方原因或不可抗力因素导致的，例如：自然灾害、交通戒严、骚乱、突发战争等",
        },
        {
          title: "其他",
          text: "1.本使用条款构成您与二白之间与您使用本网站相关的整体协议，并在此取代 您与二白之间先前存在的与使用本网站的任何及所有书面或口头协议。除在 您与二白签订的其他协议中规定的情形外，二白不接受任何对本使用条款的反要约， 且在此明确拒绝所有反要约。\n2.若二白未能坚持或强制要求严格履行本使用条款，不应被视为二白对本使用条款任何内容或执行本使用条款的任何权利的放弃，二白与您或任何其他第三方之间的任何行为不应被视为对本使用条款任何规定的修改。",
        },
      ],
    }
  },
  mounted() {},
  methods: {
    returnPage() {
      this.$router.back()
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  position: relative;
  .bg_img {
    width: 50%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .bg_img1 {
    width: 50%;
    position: absolute;
    top: 20%;
    right: 0;
  }
  .bg_img2 {
    width: 50%;
    position: absolute;
    top: 40%;
    left: 0;
  }
  .nav {
    padding: 0 20px;
    padding-top: 80px;
    .nav_head {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      .img {
        width: 30px;
        margin-bottom: 20px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
      }
      .nav_title {
        font-size: 1.25rem;
        font-weight: bold;
        background: linear-gradient(180deg, #ffffff 0%, #2e54ff 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        display: inline-block;
        text-align: center;
        margin-top: 30px;
        margin-bottom: 20px;
      }
    }
    .list {
      .list_item {
        margin-bottom: 10px;
        .title {
          width: 100%;
          color: #fff;
          font-size: .875rem;
          background: linear-gradient(to right, #2a2443 0%, #020206 100%);
          margin-bottom: 15px;
          text-align: left;
          padding-left: 10px;
        }
        .text {
          font-size: .75rem;
          color: #878c9e;
          text-align: left;
          white-space: pre-line;
        }
      }
    }
  }
}
</style>
